import React, { useState } from "react";

const TestimonialBanner = () => {
  const videos = [
    { id: "HlvzM8JebRc", title: "Happy Patient Feed back || Jabardasth Apparao || TX Hospitals" },
    { id: "RMlXckZBge8", title: "International Patient's Successful Knee Replacement by Dr.Anil Kumar || TX Hospitals" },
    { id: "uWMVkvIbbjA", title: "Happy Patient Review | Successful POEM Surgery | Dr. Vinod | Medical Gastroenterologist| TX Hospitals" },
    { id: "xYtxlt0i2OE", title: "A Satsisfied Patient Shares Their Success || DVL Naratana Rao || Gastrosurgeon || TX Hospitals" },
    { id: "fB3NCW49A0I", title: "Happy Patient Testimonials || Tonsillectomy Surgery || Dr. Karthik || TX Hsopitals"},
    { id: "ATW7DR-0YhM", title: "Patient Success Story || Atrial Septal Defect || Dr. Deepak Saha ||TX Hospitals"},
    { id: "xnaBztL7T28", title: "Kidney Transplant || Happy Patient Testimonial | #rentaltransplant || TX Hospitals " },
  ];

  const [selectedVideo, setSelectedVideo] = useState(videos[0].id);

  return (
    <>
    <h2 className="text-3xl font-bold text-gray-900 text-center mt-4">
          Patient Testimonial Videos
        </h2>
    <div className="flex flex-col md:flex-row items-stretch bg-gray-50 shadow-lg rounded-lg p-4 gap-4 h-112">
      {/* Left Panel */}
      <div className="flex-1 md:w-7/10 rounded-lg overflow-hidden shadow-md">
        <iframe
          className="w-full h-96 md:h-96 rounded-lg transition-transform duration-300 hover:scale-105"
          src={`https://www.youtube.com/embed/${selectedVideo}`}
          title="Patient Testimonial Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Right Panel */}
      <div className="md:w-3/10 flex flex-col gap-2 h-96">
        <div className="overflow-y-auto h-full pr-2">
          {/* Video List */}
          {videos.map((video) => (
            <div
              key={video.id}
              className="flex items-center gap-2 p-2 bg-white shadow-sm rounded-lg mb-2 transition-all hover:bg-gray-100 hover:shadow-md cursor-pointer"
              onClick={() => setSelectedVideo(video.id)}
            >
              <img
                className="w-64 h-32 rounded-lg object-cover"
                src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                alt={video.title}
              />
              <div className="text-sm font-medium max-w-xs break-words">
                <p>{video.title}</p>
              </div>
            </div>
          ))}
          
          {/* View More Button at the end of the list */}
          <button
            onClick={() => window.open("https://www.youtube.com/@TXHospitalsOfficial/videos", "_blank")}
            className="mt-4 px-4 py-2 text-red-600 font-semibold border-none bg-transparent hover:underline flex items-center justify-center"
          >
            View more
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default TestimonialBanner;
